import React from 'react';
import BrandLink from './BrandLink';


const MainSidebar = ({ logo, brandName, children }) => {
  return (
    <aside className='main-sidebar sidebar-dark-primary elevation-4' style={{ position: 'fixed' }}>
      <BrandLink logo={logo} name={brandName} />
      <section className='sidebar'>{children}</section>
    </aside>
  );
};


export default MainSidebar;
